import * as C from '../constants';

const DEFAULT_STATE = {};

export const authenticationData = (state = DEFAULT_STATE, action) => {
  switch (action.type) {
    case C.ADD_AUTHENTICATION_DATA:
      return {
        ...state,
        authenticationData: action.payload,
      };
    case C.LOGOUT_EXISTING_USER:
      return DEFAULT_STATE;
    default:
      return state;
  }
};
